import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        room: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ vm.room.name }}</h1>
            <a ui-sref="authorized.courses.rooms.list()" class="btn discrete">{{ 'general.Back to list' | translate }}</a>
        </div>
        <courses-rooms-form form="vm.form" room="vm.room"/>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.room, model => model.$update({ id: model.id }));
    }
}




// WEBPACK FOOTER //
// ./src/app/components/courses/rooms/detail/index.js